
import { computed, defineComponent, ref } from "vue";
import { HopDongService } from "@/core/services/HopDong.service";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import {
  IBienBanResponseBase,
  IHopDongResponseBase,
  IPhieuNhapKhoResponseBase,
  IVatTuHopDongResponseBase,
} from "@/core/interfaces/ApiResponses";
import {
  getErrorMsg,
  swalErrNotification,
  swalNotification,
} from "@/core/helpers/utils";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import { useAccount } from "@/core/hooks/use-account";
import { useLoading } from "@/core/hooks/use-loading";
import { useButtonCustom } from "@/core/hooks/use-button-custom";

import moment from "moment";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import PageContentSection from "@/layout/_shared/PageContentSection.vue";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import AddVatTuItems from "@/components/add-vat-tu-items/AddVatTuItems.vue";
import HopDongVatTuTable from "@/views/crafted/pages/hop-dong/hop-dong-vat-tu-table/HopDongVatTuTable.vue";
import BienBanKiemNghiemTable from "@/views/crafted/pages/hop-dong/bien-ban-kiem-nghiem-table/BienBanKiemNghiemTable.vue";
import BienBanKiemNghiemPrintModal from "@/components/shared/bien-ban-kiem-nghiem-print-modal/BienBanKiemNghiemPrintModal.vue";
import PhieuNhapKhoTableV2 from "@/views/crafted/pages/phieu-nhap-kho/phieu-nhap-kho-table/PhieuNhapKhoTableV2.vue";
import { openPhieuNhapKhoPdf } from "@/components/shared/pdf-viewer/open-phieu-nhap-kho-pdf";
import { openHopDongPdf } from "@/components/shared/pdf-viewer/open-hop-dong-pdf";
import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import useHopDong from "@/core/hooks/use-hop-dong";
import { AddVatTuItemsFor } from "@/core/enums/addVatTuItemsFor.enum";
import { VatTuService } from "@/core/services/VatTu.service";
import { usePagination } from "@/core/hooks/use-pagination";
import Pagination from "@/components/shared/pagination/Pagination.vue";
import debounce from "lodash/debounce";
import ResponsiveLayout from "@/layout/_shared/ResponsiveLayout.vue";
import FilterContainer from "@/layout/_shared/FilterContainer.vue";
import FilterItem from "@/layout/_shared/FilterItem.vue";
import Can from "@/components/Can.vue";
import { HOP_DONG, PHIEU_NHAP_KHO } from "@/core/constants/permissions";
import DetailTopicLottie from "@/components/shared/detail-topic-lottie/DetailTopicLottie.vue";
import { mapMutations } from "vuex";

export default defineComponent({
  name: "contract-detail",

  components: {
    DetailTopicLottie,
    FilterContainer,
    FilterItem,
    LabelCustom,
    PageContentBase,
    PageContentSection,
    AddVatTuItems,
    ButtonCustom,
    Can,
    HopDongVatTuTable,
    BienBanKiemNghiemTable,
    PhieuNhapKhoTableV2,
    BienBanKiemNghiemPrintModal,
    Pagination,
    ResponsiveLayout,
  },

  setup: function () {
    const { goBack, push, id } = useRouterCustom();

    const { startLoading, endLoading, isLoading } = useLoading();

    const { currentUserData } = useAccount();

    const { ButtonsType, ButtonTypeColors } = useButtonCustom();

    const { loaiHopDong } = useHopDong();

    const hopDong = ref<IHopDongResponseBase | null>(null);

    const hopDongVatTuItems = ref<IVatTuHopDongResponseBase[]>([]);

    const { currentPage, perPage, searchTerm, totalItems, perPageArr } =
      usePagination();

    return {
      HOP_DONG,
      PHIEU_NHAP_KHO,
      formatDate: computed(() => moment),
      goBack,
      push,
      hopDongId: id,
      loaiHopDong,
      hopDong,
      hopDongVatTuItems,
      currentUserData,
      startLoading,
      endLoading,
      isLoading,
      ButtonsType,
      ButtonTypeColors,
      currentPage,
      perPage,
      searchTerm,
      totalItems,
      perPageArr,
    };
  },

  async mounted() {
    setBreadcrumbLinks([
      {
        text: "Hợp đồng",
        routeData: {
          name: "danh-sach-hop-dong",
        },
      },
      {
        text: "Chi tiết",
      },
    ]);

    await this.fetchData();
    await this.fetchVatTuHopDong();
    this.idPhieuNhapDetail = +this.$route.query["chi-tiet-phieu-nhap"];

    if (this.idPhieuNhapDetail) {
      openPhieuNhapKhoPdf(this.$router, this.idPhieuNhapDetail);
    }

    setCurrentPageTitle(`Hợp đồng ${this.hopDong?.so_hop_dong}`);
    document.title = `${this.hopDong?.so_hop_dong} - Hợp đồng - Đường sắt Hà Nội`;
  },

  data() {
    return {
      isAddVatTuModalDisplay: false,
      isBienBanModalDisplay: false,
      idPhieuNhapDetail: null as null | number,
      openingBienBan: null as IBienBanResponseBase | null,
      AddVatTuItemsFor,
    };
  },

  computed: {
    isHoanThanh() {
      if (
        (this.hopDong &&
          Object.keys(this.hopDong.remainImport).length === 0 &&
          this.hopDong.loai_hop_dong !== 2) ||
        (this.hopDong && this.hopDong.loai_hop_dong === 2)
      ) {
        return false;
      }
      if (!this.hopDong) {
        return false;
      } else {
        let result = true;
        for (let i = 0; i < this.hopDong.remainImport.length; i++) {
          if (this.hopDong.remainImport[i].so_luong > 0) {
            result = false;
            break;
          }
        }

        return result;
      }
    },
    isHopDongHetHan() {
      if (!this.hopDong?.ngay_het_han) return false;

      return moment(new Date(this.hopDong.ngay_het_han)).isBefore(new Date());
    },
    loaiHopDongDisplay() {
      return this.loaiHopDong(this.hopDong);
    },
    showEditButton() {
      if (!this.hopDong) return false;

      return (
        this.hopDong.hoan_thanh === 0 &&
        this.hopDong.bien_ban_kiem_nghiem.length === 0
      );
    },
    phieuNhapKhoItems() {
      if (!this.hopDong?.bien_ban_kiem_nghiem) return [];

      const phieuNhapKhoData = this.hopDong.bien_ban_kiem_nghiem
        .map((bienBan) => bienBan.phieu_nhap_kho)
        .filter((phieuNhap) => phieuNhap); // Filter out null/undefined values

      phieuNhapKhoData.map((phieuNhap) => {
        return {
          ...phieuNhap,
          id_bien_ban_kiem_nghiem: 1,
        };
      });

      console.log(phieuNhapKhoData);
      return phieuNhapKhoData;
    },
  },

  watch: {
    async currentPage() {
      await this.fetchVatTuHopDong();
    },
    async perPage() {
      if (this.currentPage === 1) {
        await this.fetchVatTuHopDong();

        return;
      }

      this.currentPage = 1;
    },
  },

  methods: {
    ...mapMutations("ConfirmationDialogModule", {
      setDialog: "setDialog",
      closeDialog: "closeDialog",
    }),

    openHopDongPdfViewer() {
      openHopDongPdf(this.$router, this.hopDongId);
    },

    onDeleteButtonClick() {
      if (!this.hopDong) {
        return;
      }

      this.setDialog({
        message: `Bạn có chắc chắn muốn xoá hợp đồng số ${this.hopDong.so_hop_dong}?`,
        onConfirm: async () => {
          this.closeDialog();
          await this.startLoading();

          try {
            await HopDongService.delete(this.hopDongId);
            await this.endLoading();
            await swalNotification("Xoá hợp đồng thành công");

            this.$router.replace({
              name: "danh-sach-hop-dong",
            });
          } catch (e) {
            await this.endLoading();
            await swalErrNotification(e, "Không thể xoá hợp đồng này");
          }
        },
      });
    },

    onPhieuNhapDetailButtonClicked({
      phieuNhapKhoData,
    }: {
      phieuNhapKhoData: IPhieuNhapKhoResponseBase;
    }) {
      openPhieuNhapKhoPdf(this.$router, phieuNhapKhoData.id);
    },

    onBienBanDetailButtonClicked({
      bienBan,
    }: {
      bienBan: IBienBanResponseBase;
    }) {
      this.isBienBanModalDisplay = true;
      this.openingBienBan = bienBan;
    },

    onCloseBienBanPrintModal() {
      this.isBienBanModalDisplay = false;
      this.openingBienBan = null;
    },

    async fetchVatTuHopDong() {
      try {
        this.startLoading();

        const {
          data: {
            data: { data, total },
          },
        } = await VatTuService.getVatTuByHopDongId({
          current_page: this.currentPage,
          id: this.hopDongId,
          per_page: this.perPage,
          s: this.searchTerm,
        });

        this.hopDongVatTuItems = data.map((item) => ({
          ...item,
          id: item.id_vat_tu,
          so_luong_trong_hop_dong: item.so_luong_hop_dong,
          don_gia: item.don_gia,
        }));

        this.totalItems = total;

        this.endLoading();
      } catch (err) {
        this.endLoading();

        await swalNotification(
          getErrorMsg(err, "Có lỗi xảy ra khi lấy thông tin hợp đồng"),
          "error"
        );
      }
    },

    searchForVatTuHopDong: debounce(function () {
      this.fetchVatTuHopDong();
    }, 500),

    async fetchData() {
      try {
        this.startLoading();

        const {
          data: { data: res },
        } = await HopDongService.fetchContractDetail(this.hopDongId);

        this.hopDong = res;

        this.hopDongVatTuItems = [];

        this.endLoading();
      } catch (err) {
        this.endLoading();

        await swalNotification(
          getErrorMsg(err, "Có lỗi xảy ra khi lấy thông tin hợp đồng"),
          "error"
        );
      }
    },

    onAddVatTuButtonClicked() {
      this.isAddVatTuModalDisplay = true;
    },

    async onAddedVatTuItems() {
      this.isAddVatTuModalDisplay = false;

      await this.fetchData();

      await this.fetchVatTuHopDong();
    },

    onAddPhieuNhapButtonClickHandler() {
      this.push({
        name: "tao-moi-phieu-nhap-kho",
        query: {
          idHopDong: String(this.hopDongId),
        },
      });
    },
  },
});
